import React from 'react';
import Checkbox from 'components/base/Checkbox';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { getColor } from 'common/constants/_colors';
import Tooltip from '@material-ui/core/Tooltip';

const CheckboxWithoutHover = styled(Checkbox)`
  :hover {
    background-color: transparent !important;
  }
`;

const SelectableItemWrapper = styled(Flex)`
  background-color: ${getColor('white')};
  width: 94%;
  margin: 0.5rem 0;
  border-radius: 0.5rem;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  ${({ checked }) =>
    checked
      ? `border: 1px solid ${getColor('dodgerBlue')};`
      : `border: 1px solid ${getColor('botticelli')};`}
`;

const SelectableItem = ({
  title,
  description,
  checked,
  toggleSelection,
  disabled
}) => {
  const disableSelection = disabled && !checked;
  return (
    <SelectableItemWrapper
      items='start'
      padding='small'
      {...(disableSelection ? {} : { onClick: toggleSelection })}
      checked={checked}
      disabled={disableSelection}
      data-cy={`select-metric-${title}`}
    >
      <CheckboxWithoutHover
        disableRipple
        checked={checked}
        disabled={disableSelection}
      />
      <Flex direction='column' pl='x-small'>
        <Text
          mt='0.5rem'
          size='medium'
          {...(checked
            ? { color: 'dodgerBlue' }
            : disableSelection
            ? { color: 'silverSand' }
            : {})}
        >
          {title}
        </Text>
        <Tooltip title={<Flex maxWidth='17rem'>{description}</Flex>}>
          <Text
            mt='0.3rem'
            {...(checked
              ? { color: 'dodgerBlue', alpha: 0.6 }
              : disableSelection
              ? { color: 'silverSand' }
              : { color: 'shuttleGray' })}
            lineHeight='150%'
            multiLineEllipsisAfter={2}
          >
            {description}
          </Text>
        </Tooltip>
      </Flex>
    </SelectableItemWrapper>
  );
};

export default SelectableItem;
